import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=4aadd3e7&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=js"
export * from "./NotificationModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=4aadd3e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aadd3e7",
  null
  
)

export default component.exports